module.exports = __webpack_public_path__ + "static/git-rebase-v-merge-2-71a0ffa05f83cc682c20fbe39ac8bd8a.png";